import { Reducer } from 'redux';
import { produce } from 'immer';

import { REPORTS_TYPES, ReportsState } from './types';

export const INITIAL_STATE: ReportsState = {
  reports: {
    hasMore: false,
    response: [],
  },
  error: null,
};

const reducer: Reducer<ReportsState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case REPORTS_TYPES.SET_DATA_REPORTS:
        draft.reports = action.payload;
        break;
      case REPORTS_TYPES.SET_ERROR:
        draft.error = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
